<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head">PREFACE</p>
<p class="noindent">Inside these pages you’ll find some odd, scandalous and remarkable true tales from New Hampshire’s storied history—enjoy! One of the lovely things about the New England states is how many of our historic places are protected and still standing. If you’re moved to explore some of the places that you read about in this book, I encourage it wholeheartedly. Many of the people you’re about to learn about moved around in spaces that still exist to this day. In many towns, you’ll find all kinds of guided history walks that will show you around notable places in New Hampshire. But please keep in mind that not all of these places are open for tours. Many historic homes are, to this day, just that—someone’s home. Please ask before exploring and use your best judgment about what places are open to the public and which are not.</p>
<p class="indent">Your local historical society is a valuable resource if you’re looking for some wicked history in your own town. New Hampshire has long been home to a quirky cast of eccentrics, and it seems like every city and town in the Granite State has a few wicked tales in its past.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Preface.vue?282d3ada